import '../App.css';
import { useState, useEffect } from 'react';
import pic_smile from '../images/pics/profile-pic-smile.png'
import pic_candid from '../images/pics/profile-pic-candid.png'
import arrow_down from '../images/pics/arrow-down.png'
import { scrollToSection } from './Header';
import { useTitleCardPos } from '../TitleCards';


export default function ProfileBlurb() {

    const { profile, project } = useTitleCardPos();

    const [topArrowVisible, setTopArrowVisible] = useState(true);
    const [botArrowVisible, setBotArrowVisible] = useState(true);

    const [slide, setSlide] = useState(false);

    
    useEffect(() => {
        const onScroll = () => {
            const scroll = window.scrollY;
            const top_arrow = scroll < 345 ? true : false;
            const bot_arrow = scroll < 1100 ? true : false;
            if (scroll > 270) {
                setSlide(true);
            }
            setTopArrowVisible(top_arrow);
            setBotArrowVisible(bot_arrow);
        }
    
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <div> 

            {topArrowVisible ? /** BLUE DIV 1 */
            <span className='arrow-down' style={{ marginBottom: '150px' }}>
                <img
                src={arrow_down} 
                alt='arrow going down'
                onClick={() => scrollToSection('profile', profile)}
                />
            </span> : <span style={{ marginBottom: '150px' }} className='arrow-down'/>
            }



            {/*Title of page section*/}
            <div ref={profile} className='title-container'>
                <div className='title'>
                    About <span style={{ color: '#598fcb' }}>Me</span>
                </div>
            </div>



            {/*Profile Section Start*/}
            <div className='profile-container'>
                <div className='profile'> {/* BLUE DIV 2 */}

                    {/*Profile Blurb == Left Side*/}
                    {/** GREEN DIV 1 */}
                    {/**<div onClick={() => changeBlurb(false)} className='button-container'>
                        <span  className='blurb-button'>{`<`}</span>
                    </div>*/}
                    <Intro
                    slide={slide}
                    />
                    {/** <div onClick={() => changeBlurb(true)} className='button-container'>
                        <span  className='blurb-button'>{`>`}</span>
                    </div> */}
                    
                    {/*Profile Picture == right Side*/}
                    <div className='pic-container'> {/** GREEN DIV 2 */}
                        <img 
                        src={pic_smile} 
                        alt='profile pic' 
                        className={'profile-pic smile-pic'} 
                        style={{ opacity: slide ? '100%' : '0%'}}></img> {/** PINK IMAGE 1 */}
                        <img 
                        src={pic_candid} 
                        alt='profile pic' 
                        className={'profile-pic candid-pic'} 
                        style={{ opacity: slide ? '100%' : '0%'}}></img>{/** PINK IMAGE 2 goes here */}
                    </div>
                </div>
                <div className='attributes'>
                    {DotPoint(<div><span style={{ fontWeight: '600' }}>Age</span>: 24</div>)}
                    {DotPoint(<div><span style={{ fontWeight: '600' }}>Based</span>: Brisbane, Aus</div>)}
                    {DotPoint(<div><span style={{ fontWeight: '600' }}>Qualifications</span>: Bachelor of Information Technology (UQ)</div>)}
                </div>
            </div>



            {botArrowVisible ? /** BLUE DIV 3 */
            <span className='arrow-down'>
                <img 
                src={arrow_down} 
                alt='arrow going down'
                
                onClick={() => scrollToSection('project', project)}
                />
            </span> : <span className='arrow-down'/>
            }



            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className='line'/>
            </div>
        </div>
    )
}


export function DotPoint(label, subPoint=[]) {

    const dot_point_width = 40
    const dot_point_height = 50

    const mid_point_x = 15
    const mid_point_y = 25

    return (
        <div className='dotpoint-container'>
            {subPoint.length > 0 ?
                <div style={{display: 'block'}}>
                    <div style={{ display: 'flex', alignItems: 'center'}}>
                        <svg width={dot_point_width} height={dot_point_height}>
                            <circle cx={mid_point_x} cy={mid_point_y} r="5" fill='none' stroke='#598fcb' strokeWidth='3'/>
                        </svg>
                        <span>
                            <p>{label}</p>
                        </span>
                    </div>
                    {subPoint.map(subPnt => (
                        <div style={{ display: 'flex', alignItems: 'center',  marginLeft: '30px', height: '50px' }}>
                            <svg width={dot_point_width} height='50'>
                                <rect x={mid_point_x} y={mid_point_y} width="5" height="5" fill='none' stroke='#598fcb' strokeWidth='3'/>
                            </svg>
                            <span>
                                <p>{subPnt}</p>
                            </span>
                        </div>
                    ))}
                </div>
                :
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div style={{ minWidth: '50px'}}>
                        <svg width={dot_point_width} height={dot_point_height}>
                            <circle cx={mid_point_x} cy={mid_point_y} r="5" fill='none' stroke='#598fcb' strokeWidth='3'/>
                        </svg>
                    </div>
                    <div className='attribute-label'>
                        {label}
                    </div>
                </div>
            }
        </div>
    )
}

function Intro({ slide }) {

    return (
        <div className={'blurb-container'} style={{ height:'100%', opacity: slide ? '100%' : '0%'}}>
            <div className='blurb'> {/** Board with blurb and descriptions */}
                <div className='blurb-title'>William Harvey</div>
                <span style={{ color: '#5198cd' }}>IT Graduate & UX Web Designer</span>

                <p>Hi and welcome! I'm Will, a Bachelor of Information Technology 
                graduate with a double major in UX/UI Design and Software Design. 
                I'm passionate about designing and building intuitive apps and 
                websites, combining strong technical foundations with a user-centred 
                mindset. My long-term goal is to move into cybersecurity, where I 
                can apply my skills in software development, systems thinking, and 
                UX to help build secure, usable, and resilient digital products. 
                Through my studies and personal projects, I've gained hands-on 
                experience turning ideas into functional solutions while continually 
                expanding my knowledge across development, design, and security.</p>

            </div>
        </div>
    )
}

/**
function Attributes({ attributes }) {

    return (
        <div>
            <div className='attribute-container'>
                {attributes.map(attribute => (
                    <div key={attribute} className='attributes'>
                        {attribute}
                    </div>
                ))}
            </div>
        </div>
    )
}

 These are extra cards I may add in the future as well as the button functionality
function Education() {

    return (
        <div>
            <div className='blurb'> {/** Board with blurb and descriptions }
                <h2>Education</h2>
                {DotPoint("University of Queensland", ["Bachelor of Information Technology", "Double major in UX/UI and Software Design"])}
                {DotPoint("Other Education Example", ["Sub Edu 1", "Sub edu 2"])}
            </div> 
        </div>
    )
}

function More() {


    return (
        <div>
            <div className='blurb'> {/** Board with blurb and descriptions }
                <h2>More About Me</h2>
                {DotPoint("Age", ["24"])}
                <div style={{ margin: '15px' }}/>
                {DotPoint("Hobbies?", ["Sub Hobby 1", "Sub Hobby 2"])}
            </div> 
        </div>
    )
}

    const [ blurbState, setBlurbState ] = useState(0);

    const changeBlurb = (direction) => {
        console.log(direction);
        console.log(blurbState);
        if (direction) {
            const inc = blurbState < 2 ? 1 : 0;
            setBlurbState(blurbState => blurbState + inc);
        } else {
            const inc = blurbState > 0 ? 1 : 0;
            setBlurbState(blurbState => blurbState - inc);
        }
    }

*/